import { render, staticRenderFns } from "./OutboundLink.vue?vue&type=template&id=99e6ad9a&"
import script from "./OutboundLink.vue?vue&type=script&lang=js&"
export * from "./OutboundLink.vue?vue&type=script&lang=js&"
import style0 from "./OutboundLink.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports